import type { ConsumoDoPar, ModalidadeCobranca, MotivoNaoEmite } from "@/api/contrato";
import { quantidade } from "@/formato";

/*
 * Leituras do vínculo aplicação × cedente — change `add-cobranca-por-cedente`.
 *
 * Ficam juntas porque as duas telas que mostram um vínculo (a aba Cedentes da
 * aplicação e a seção Aplicações do beneficiário) precisam dizer a mesma coisa
 * com as mesmas palavras: "todos" numa e "sem restrição" na outra fariam o
 * operador perguntar se são estados diferentes.
 */

export const ROTULO_DA_MODALIDADE: Record<ModalidadeCobranca, string> = {
  por_sistema: "pela aplicação",
  por_cedente: "por cedente",
};

/**
 * Os convênios que o vínculo permite.
 *
 * `null` é TODOS, `[]` é NENHUM (pendência P16: ausente, nulo e vazio são três
 * coisas). Ler o vazio como "todos" seria dizer ao operador que um integrador
 * emite por convênios que ele não alcança — ou o contrário, na pior direção.
 */
export function resumoDosConvenios(convenios: readonly string[] | null): string {
  if (convenios === null) return "todos";
  if (convenios.length === 0) return "nenhum";
  return convenios.length === 1 ? "1 convênio" : `${convenios.length} convênios`;
}

/**
 * O consumo do par na competência, contra o teto que decide o par.
 *
 * `teto_efetivo` nulo é "sem teto próprio" — o par só responde ao teto da
 * aplicação —, e nunca zero: zero seria um cedente que não emite nada.
 */
export function consumoDoPar(consumo: ConsumoDoPar): string {
  if (consumo.teto_efetivo === null) return `${quantidade(consumo.emitidos)} · sem teto`;
  return `${quantidade(consumo.emitidos)}/${quantidade(consumo.teto_efetivo)}`;
}

/*
 * O primeiro elo quebrado da cadeia do par, em palavras de tela.
 *
 * `Record` sobre o enum do contrato: motivo novo não compila até ganhar texto. O
 * rótulo diz o fato, e o caminho até ele é a pendência do cedente, com a ação.
 */
export const MOTIVO_DE_NAO_EMITIR: Record<NonNullable<MotivoNaoEmite>, string> = {
  cedente_bloqueado: "Cedente bloqueado.",
  certificado_vencido: "Certificado vencido.",
  aplicacao_suspensa: "Aplicação suspensa.",
  aplicacao_sem_contrato: "Aplicação sem contrato vigente.",
  vinculo_suspenso: "Vínculo suspenso.",
  vinculo_sem_contrato: "Sem contrato vigente.",
  vinculo_sem_convenio: "Nenhum convênio liberado.",
  sem_chave: "Sem chave de emissão.",
};
